import { render, staticRenderFns } from "./HistoryUserDentistAll.vue?vue&type=template&id=314ef055&scoped=true&"
import script from "./HistoryUserDentistAll.vue?vue&type=script&lang=js&"
export * from "./HistoryUserDentistAll.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUserDentistAll.vue?vue&type=style&index=0&id=314ef055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ef055",
  null
  
)

export default component.exports